import dayjs from "dayjs";
import { isEmpty, isNil } from "ramda";
import { CURRENCIES, EXTERNAL_OWNER } from "../constants";
import { propIsNull } from "../shared/util";
export const TIME_ZONE = function getTimeZone() {
  const d = new Date();
  let localHours = d.getHours();
  let localDate = d.getDate();
  const utcDate = d.getUTCDate();
  const diff = localDate - utcDate;
  switch (diff) {
    case -1:
      localHours -= 24;
      break;
    case 0:
      break;
    case 1:
      localHours += 24;
      break;
    default:
      if (diff > 0) {
        localHours -= 24;
      } else {
        localHours += 24;
      }
  }
  return localHours - d.getUTCHours();
}();
export const fetchUserName = (userId, userMap) => {
  const user = userMap[userId];
  if (!user) return userId === "CC4123F2258411EB9A4A7CD30AB8A430" ? "连接派" : userId === EXTERNAL_OWNER ? "待认领" : "未知用户";
  return user?.nick_name;
};
export function convertDateTime(t, interval = "day") {
  if (propIsNull(t)) return null;
  const d = typeof t === "number" ? new Date(t + (8 - TIME_ZONE) * 3600_000) : t?.constructor === Date ? new Date(t.valueOf() + (8 - TIME_ZONE) * 3600_000) : new Date(new Date(t).valueOf() + (8 - TIME_ZONE) * 3600_000);
  if (Number.isNaN(d.valueOf())) return null;
  switch (interval) {
    case "year":
      return `${d.getFullYear()}`;
    case "mon":
      return `${d.getFullYear()}/${(d.getMonth() + 101).toString().slice(1)}`;
    case "YEAR_MONTH_DASHED":
      return `${d.getFullYear()}-${(d.getMonth() + 101).toString().slice(1)}`;
    case "MON":
      return `${(d.getMonth() + 101).toString().slice(1)}`;
    case "YEAR_MONTH":
      return `${d.getFullYear()}${(d.getMonth() + 101).toString().slice(1)}`;
    case "hour":
      return `${d.getFullYear()}/${(d.getMonth() + 101).toString().slice(1)}/${(d.getDate() + 100).toString().slice(1)} ${(d.getHours() + 100).toString().slice(1)}:00`;
    case "SEC":
      return `${d.getFullYear()}${(d.getMonth() + 101).toString().slice(1)}${(d.getDate() + 100).toString().slice(1)}${(d.getHours() + 100).toString().slice(1)}${(d.getMinutes() + 100).toString().slice(1)}${(d.getSeconds() + 100).toString().slice(1)}`;
    case "tms":
      return `${(d.getHours() + 100).toString().slice(1)}:${(d.getMinutes() + 100).toString().slice(1)}:${(d.getSeconds() + 100).toString().slice(1)}.${(d.getMilliseconds() + 1000).toString().slice(1)}`;
    case "ms":
      return `${d.getFullYear()}/${(d.getMonth() + 101).toString().slice(1)}/${(d.getDate() + 100).toString().slice(1)} ${(d.getHours() + 100).toString().slice(1)}:${(d.getMinutes() + 100).toString().slice(1)}:${(d.getSeconds() + 100).toString().slice(1)}.${(d.getMilliseconds() + 1000).toString().slice(1)}`;
    case "MS":
      return `${d.getFullYear()}${(d.getMonth() + 101).toString().slice(1)}${(d.getDate() + 100).toString().slice(1)}${(d.getHours() + 100).toString().slice(1)}${(d.getMinutes() + 100).toString().slice(1)}${(d.getSeconds() + 100).toString().slice(1)}${(d.getMilliseconds() + 1000).toString().slice(1)}`;
    case "MIN":
      return `${d.getFullYear()}${(d.getMonth() + 101).toString().slice(1)}${(d.getDate() + 100).toString().slice(1)}${(d.getHours() + 100).toString().slice(1)}${(d.getMinutes() + 100).toString().slice(1)}`;
    case "min":
      return `${d.getFullYear()}/${(d.getMonth() + 101).toString().slice(1)}/${(d.getDate() + 100).toString().slice(1)} ${(d.getHours() + 100).toString().slice(1)}:${(d.getMinutes() + 100).toString().slice(1)}`;
    case "DAY":
      return `${d.getFullYear()}${(d.getMonth() + 101).toString().slice(1)}${(d.getDate() + 100).toString().slice(1)}`;
    case "DAY_DASHED":
      return `${d.getFullYear()}-${(d.getMonth() + 101).toString().slice(1)}-${(d.getDate() + 100).toString().slice(1)}`;
    case "DAY_SLASH_REVERSE":
      return `${(d.getDate() + 100).toString().slice(1)}/${(d.getMonth() + 101).toString().slice(1)}/${d.getFullYear()}`;
    case "MIN_DASHED":
      return `${d.getFullYear()}-${(d.getMonth() + 101).toString().slice(1)}-${(d.getDate() + 100).toString().slice(1)} ${(d.getHours() + 100).toString().slice(1)}:${(d.getMinutes() + 100).toString().slice(1)}`;
    case "MON_DAY_SLASH":
      return `${(d.getMonth() + 101).toString().slice(1)}/${(d.getDate() + 100).toString().slice(1)}`;
    case "MON_DAY_DASHED":
      return `${(d.getMonth() + 101).toString().slice(1)}-${(d.getDate() + 100).toString().slice(1)}`;
    case "MON_DAY":
      return `${(d.getMonth() + 101).toString().slice(1)}${(d.getDate() + 100).toString().slice(1)}`;
    case "MONTH_DAY":
      return `${(d.getDate() + 100).toString().slice(1)}`;
    case "day":
    default:
      return `${d.getFullYear()}/${(d.getMonth() + 101).toString().slice(1)}/${(d.getDate() + 100).toString().slice(1)}`;
  }
}
export function displayText(value, separator = ";") {
  if (propIsNull(value)) return null;
  return Array.isArray(value) ? value.join(separator) : value;
}
export function displayUser(value, userMap = {}, separator = ";") {
  if (propIsNull(value)) return null;
  return (Array.isArray(value) ? value : [value]).map((x, index) => fetchUserName(x, userMap)).join(separator);
}
export function displayNumber(value, separator = ";", precision = 0, unit = "", numericalFormat = 0) {
  if (propIsNull(value) || !Number.isFinite(Number(value))) return null;
  return (Array.isArray(value) ? value : [value]).map(sv => (numericalFormat ? Number(sv) * 100 : Number(sv)).toFixed(precision || 0).concat(numericalFormat ? "%" : "", unit || "")).join(separator);
}
export function displayCascade(value, separator = ";", hideRoutes = false) {
  if (propIsNull(value) || !Array.isArray(value)) return null;
  return value.map(x => {
    return typeof x === "string" ? x : hideRoutes ? x[x.length - 1] : x.join("/");
  }).join(separator);
}
export function displayCurrency(value, separator = ";", precision = 2, type = "CNY") {
  if (propIsNull(value) || !Number.isFinite(Number(value))) return null;
  const symbol = CURRENCIES.find(x => x.type === type)?.symbol || "CN¥";
  return (Array.isArray(value) ? value : [value]).map(sv => symbol.concat(Number(sv).toFixed(precision))).join(separator);
}

/**
 * 获取条件匹配对应的公式
 * @param prop 属性配置
 * @param rootId 空间根节点id
 * @returns {null|{op: string, input: {temp_id: *, remoteProp: number[], prop: *, quotaProp: (number|number), type: string}[]}}
 */
export function genMatchingFormula(prop, rootId) {
  if (!prop || !prop.conditionMatching || !Array.isArray(prop.matchingProp)) return null;
  let op = "";
  switch (prop.matchingType) {
    case -1:
      op = `pass_array`;
      break;
    case 0:
      op = prop.multiple ? "pass_any" : "pass";
      break;
    case 1:
      op = "sum";
      break;
    case 2:
      op = "avg";
      break;
    case 3:
      op = "max";
      break;
    case 4:
      op = "min";
      break;
    case 5:
      op = "count";
      break;
  }
  if (op) {
    const _quota = {
      type: "quota",
      temp_id: prop.matchingTemplate,
      prop: prop.conditionProp,
      remoteProp: prop.quoteProp.map(p => Number(p.split("-")[1])),
      quotaProp: prop.matchingType === 5 ? -4 : Number.isFinite(Number(prop.matchingProp[0])) ? Number(prop.matchingProp[0]) : prop.matchingProp.map(p => Number(p.split("-")[1]))[0],
      auxiliaryProp: prop.auxiliaryProp?.index ?? undefined
    };
    const quota = _quota;
    if (prop.matchingSource && prop.matchingSource !== rootId) quota["parentId"] = prop.matchingSource;
    if (prop.filterFormula) quota.formula = prop.filterFormula;
    return {
      op,
      input: [quota]
    };
  }
  return null;
}
export const genNumberLimit = (prop, tempProp, type = "upper") => {
  return prop.numberLimit ? prop.numberLimit[type].type === "const" ? Number.isFinite(prop.numberLimit[type].const) ? prop.numberLimit[type].const : null : Array.isArray(tempProp[prop.numberLimit[type].prop]) ? !propIsNull(tempProp[prop.numberLimit[type].prop][0]) && Number.isFinite(Number(tempProp[prop.numberLimit[type].prop][0])) ? Number(tempProp[prop.numberLimit[type].prop][0]) : null : !propIsNull(tempProp[prop.numberLimit[type].prop]) && Number.isFinite(Number(tempProp[prop.numberLimit[type].prop])) ? Number(tempProp[prop.numberLimit[type].prop]) : null : Number.isFinite(prop.number?.[type + "Limit"]) ? prop.number[type + "Limit"] : null;
};
export const convertTimeByModule = (e, module = "day", hour = -1) => {
  if (dayjs(e).isValid()) {
    let d = e.valueOf();
    switch (module) {
      case "time":
        return (e.hour() * 60 + e.minute()) * 60_000;
      case "meridiem":
        return e.hour((~hour ? hour : e.hour()) > 12 ? 14 : 8).minute(0).second(0).millisecond(0).valueOf();
      case "month":
        d += TIME_ZONE * 3600_000;
        return d - d % 86_400_000 + 43_200_000 - (new Date(d).getUTCDate() - 2) * 86_400_000;
      case "year":
        d += TIME_ZONE * 3600_000;
        return new Date(`${new Date(d).getUTCFullYear()}-01-02 12:00:00 GMT+0000`).valueOf();
      case "min":
        return d - d % 60_000;
      default:
        d += TIME_ZONE * 3600_000;
        return d - d % 86_400_000 + 43_200_000;
    }
  }
  return null;
};
export const checkDisabledDate = (current, module = "day", limit, propValues = []) => {
  if (!current) return false;
  const dateModule = module === "meridiem" ? "day" : module;
  let [upper, lower] = [limit?.upper?.type === "prop" ? propValues[limit.upper.prop] : limit?.upper?.const, limit?.lower?.type === "prop" ? propValues[limit.lower.prop] : limit?.lower?.const];
  if (module === "min" || module === "hour") {
    [upper, lower] = [dayjs(upper).endOf("day"), dayjs(lower).startOf("day")];
  }
  if (module === "time") {
    const milliseconds = (current.hour() * 60 + current.minute()) * 60_000;
    return upper && milliseconds > dayjs(upper).endOf("day").valueOf() || lower && milliseconds < dayjs(lower).startOf("day").valueOf();
  }
  return upper && current > dayjs(upper).endOf(dateModule) || lower && current < dayjs(lower).startOf(dateModule);
};

/**
 * 生成状态默认的流转配置
 * @param taskStatus 主题类型的状态
 * @param index 当前状态的索引
 * @param {import('@/types/ApiResponse/CurrentUser').CurrentUser.taskStatus|undefined}states 排序好的状态，不必传
 * @param sortedIndex 当前状态在排序好的状态中的位置，不必传
 * @returns {import('@/types/ApiResponse/CurrentUser').CurrentUser.FlowRoute[]}
 */
export const genDefaultFlowSetting = (taskStatus, index, states, sortedIndex) => {
  if (!states) {
    const newData = Array.isArray(taskStatus) ? [...taskStatus] : [];
    newData.map((x, i) => {
      if (x) {
        x.index = i;
        if (!("sort" in x)) x.sort = i;
      }
    });
    newData.sort((b, a) => b.sort - a.sort);
    states = newData.filter(status => status && !status.delete);
    sortedIndex = states.findIndex(state => state.index === index);
  }
  const s = states[sortedIndex];
  if (!s) return [];
  if (s.newAddState && (isNil(s.flow) || isEmpty(s.flow))) return [];
  return states.filter(state => state.index !== index && (!s.flow || s.flow.includes(state.index))).map(state => {
    const setting = s.flowSetting?.find(x => x.index === state.index);
    return {
      index: state.index,
      color: setting?.color || "#6B7A96",
      name: setting?.name || state.name,
      transferable: setting?.transferable,
      transType: setting?.transType
    };
  });
};